import Vue from 'vue';
import Vuex from 'vuex';
import user from './moudles/user.js';
import apphandle from "./moudles/apphandle.js";
import notice from "./moudles/notice.js";
import knowledge from "@/store/moudles/knowledge";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);
const store = new Vuex.Store({
    modules: {
        user,
        apphandle,
        notice,
        knowledge
    },
    plugins: [
        // 仅持久化 user 模块中的 certifiedUserInfo 字段
        createPersistedState({
            paths: ["user.certifiedUserInfo"], // 按模块路径指定字段
            storage: window.localStorage,      // 默认用 localStorage
        })
    ]
});
export default store;